export function timeConverter(UNIX_timestamp) {
    var a = new Date(UNIX_timestamp * 1000);
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    var year = a.getFullYear();
    //var month = months[a.getMonth()];
    var month =
        a.getMonth() >= 9 ? a.getMonth() + 1 : "0" + eval(a.getMonth() + 1);
    var date = a.getDate() >= 10 ? a.getDate() : "0" + a.getDate();
    var hour = a.getHours() >= 10 ? a.getHours() : "0" + a.getHours();
    var min = a.getMinutes() >= 10 ? a.getMinutes() : "0" + a.getMinutes();
    var sec = a.getSeconds() >= 10 ? a.getSeconds() : "0" + a.getSeconds();
    // var time =
    //   date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
    var time =
        year + "/" + month + "/" + date + " " + hour + ":" + min + ":" + sec;
    // var time = date + " " + month + " " + year;
    return time;
}
export function from_0(value) {
    let fromdate = new Date(value);
    return new Date(
        fromdate.getFullYear(),
        fromdate.getMonth(),
        fromdate.getDate(),
        0,
        0,
        0,
        0
    );
}
export function to_24(value) {
    const toDate = new Date(value);
    return new Date(
        toDate.getFullYear(),
        toDate.getMonth(),
        toDate.getDate() + 1,
        0,
        0,
        0,
        0
    );
}
export function getDateLabel(from, to) {
    const fromDate = new Date(from);
    const toDate = new Date(to);

    if ((fromDate.getFullYear() == toDate.getFullYear()) && (fromDate.getMonth() == toDate.getMonth()) && (fromDate.getDate() == toDate.getDate())) {
        return fromDate.getFullYear() + "-" + (eval(fromDate.getMonth()) + 1) + "-" + fromDate.getDate();
    }
    return fromDate.getFullYear() + "-" + (eval(fromDate.getMonth()) + 1) + "-" + fromDate.getDate() + "~" + toDate.getFullYear() + "-" + (eval(toDate.getMonth()) + 1) + "-" + toDate.getDate()

}



